import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import RiseLoader from "react-spinners/RiseLoader";

import { history } from "@helpers/history";
import { fetchWrapper } from "@helpers/fetchwrapper";

import CardArrow from "@areas/shared/components/cards/CardArrow";

import styles from "./styles/newPassword.module.css";

function NewPassword({ login, hash }) {
  const authToken = useSelector((x) => x.auth.token);
  const [forgotResult, setForgotResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (authToken) {
      history.navigate("/personal");
    }
  }, [authToken]);

  const validationSchema = Yup.object().shape({
    login: Yup.string(),
    hash: Yup.string(),
    password: Yup.string().required("Пароль обязателен"),
    confirmPassword: Yup.string()
      .required()
      .oneOf([Yup.ref("password"), null], "Пароли не совпадают"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors, isSubmitting } = formState;

  function onSubmit({ login, hash, password }) {
    setError(null);
    setForgotResult(null);
    return fetchWrapper
      .post(
        `/v1/personal/restorepassword?login=${login}&hashId=${hash}&newPass=${password}`
      )
      .then((result) => {
        setForgotResult(result);
        if (result) {
          history.navigate("/personal/login");
        } else {
          setError("Не удалось сбросить пароль");
        }
      })
      .catch((rejectedValueOrSerializedError) => {
        setForgotResult(false);
        setError(rejectedValueOrSerializedError);
      });
  }

  return (
    <div className={styles.block}>
      <CardArrow
        customStyles={{
          main: styles.card,
        }}
        sizeArrow={{ width: 20, height: 20 }}
        rotate="rightTop"
      >
        <form className={styles.inner} onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.title}>Забыли пароль</div>
          <input
            type="text"
            {...register("login")}
            defaultValue={login}
            hidden={true}
          />
          <input
            type="text"
            {...register("hash")}
            defaultValue={hash}
            hidden={true}
          />
          <div className={styles.formGroup}>
            <input
              type="password"
              {...register("password")}
              className={`${
                errors.password ? styles.inputError : styles.input
              }`}
              placeholder="Пароль"
            />
            <div className={styles.errorMessage}>
              {errors.password?.message}
            </div>
          </div>
          <div className={styles.formGroup}>
            <input
              type="password"
              {...register("confirmPassword")}
              className={`${
                errors.confirmPassword ? styles.inputError : styles.input
              }`}
              placeholder="Повторите пароль"
            />
            <div className={styles.errorMessage}>
              {errors.confirmPassword?.message}
            </div>
          </div>
          <div className={styles.submit}>
            {isSubmitting ? (
              <RiseLoader className={styles.bar} color="#014170" />
            ) : (
              <>
                <button className={styles.btn}>Сбросить пароль</button>
                {forgotResult !== null && (
                  <>
                    {forgotResult ? (
                      <div className={styles.submitSuccess}>Пароль изменен</div>
                    ) : (
                      <div className={styles.submitError}>{error}</div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <div className={styles.addition}>
            <Link to="/personal/login" className={styles.link}>
              Войти
            </Link>
          </div>
        </form>
      </CardArrow>
    </div>
  );
}

export default NewPassword;
